// Translations for the portfolio
export const translations = {
  fr: {
    // Navigation
    nav: {
      about: "À propos",
      skills: "Compétences",
      experience: "Expériences",
      education: "Formations",
      projects: "Projets",
      contact: "Contact"
    },
    // Header
    header: {
      title: "Intervenant en Santé Mentale · Coach en parentalité"
    },
    // About Section
    about: {
      title: "À propos",
      subtitle: "Intervenant en santé mentale, coach en parentalité et professionnel engagé dans la protection de l'enfance, la coopération internationale et l'innovation en santé mentale.",
      bio: "J'accompagne des familles, des équipes et des organisations dans la gestion du stress, la santé mentale, la parentalité et le développement du leadership. Mon expérience s'étend des contextes humanitaires aux environnements corporatifs, en passant par la formation et l'accompagnement psychosocial. Mon approche est à la fois clinique, éducative et stratégique, avec une attention particulière à la dignité, à la résilience et à l'inclusion des personnes accompagnées.",
      expertise: [
        "Santé mentale & psychosocial",
        "Protection de l'enfance",
        "Coopération internationale",
        "Coaching & leadership",
        "Innovation numérique en santé mentale"
      ]
    },
    // Skills Section
    skills: {
      title: "Compétences",
      subtitle: "Un socle combinant santé mentale, protection, gestion de projet, pédagogie et outils numériques.",
      mentalHealth: "Santé mentale & psychosocial",
      protection: "Protection & humanitaire",
      leadership: "Leadership, coaching & opérations",
      pedagogy: "Analyse, pédagogie & numérique",
      tools: "Outils",
      languages: "Langues",
      mentalHealthSkills: [
        "Prise en charge psychologique et psychosociale individuelle, familiale et de groupe",
        "Évaluation des besoins en santé mentale et élaboration de plans de traitement",
        "Premiers secours psychologiques (PSP) et accompagnement en contexte de crise",
        "Supervision et soutien des équipes de terrain sur les aspects psychosociaux"
      ],
      protectionSkills: [
        "Protection de l'enfance, VBG, gestion de cas et dispositifs de référencement",
        "Analyse des besoins des populations affectées par les chocs et conflits",
        "Collaboration avec ONG, agences onusiennes et acteurs institutionnels"
      ],
      leadershipSkills: [
        "Coaching en parentalité, développement personnel et leadership",
        "Accompagnement de cadres et managers dans la prise de décision",
        "Analyse et optimisation des processus opérationnels"
      ],
      pedagogySkills: [
        "Conception et animation de formations (présentielles et en ligne)",
        "Expérience en annotation d'IA et conception d'outils numériques en santé mentale"
      ]
    },
    // Experience Section
    experience: {
      title: "Expériences professionnelles",
      subtitle: "Un parcours à l'interface de la santé mentale, de la protection, de l'humanitaire et des environnements corporatifs."
    },
    // Education Section
    education: {
      title: "Formations & diplômes",
      subtitle: "Un parcours académique ancré en psychologie, sciences de l'éducation, santé mentale et coopération internationale.",
      degrees: "Diplômes principaux",
      certifications: "Certifications sélectionnées"
    },
    // Projects Section
    projects: {
      title: "Projets & engagements",
      subtitle: "Des initiatives à l'intersection de la santé mentale, du numérique et de la formation.",
      engagements: "Engagements professionnels"
    },
    // Contact Section
    contact: {
      title: "Contact",
      subtitle: "Pour toute collaboration, mission, coaching ou projet en santé mentale, protection ou formation.",
      email: "E-mail",
      languages: "Langues",
      location: "Localisation actuelle",
      sendMessage: "Envoyez-moi un message",
      fullName: "Nom complet",
      yourName: "Votre nom",
      subject: "Sujet",
      subjectPlaceholder: "Sujet de votre message",
      message: "Message",
      messagePlaceholder: "Écrivez votre message ici...",
      send: "Envoyer le message"
    },
    // Door messages
    door: {
      apropos: { title: "Bienvenue", message: "Je vous ouvre la porte sur mon parcours." },
      competences: { title: "Compétences clés", message: "Je vous ouvre la porte sur mon expertise." },
      experiences: { title: "Expériences", message: "Je vous ouvre la porte sur mon terrain d'action." },
      formations: { title: "Formations", message: "Je vous ouvre la porte sur mon parcours académique." },
      resultats: { title: "Résultats", message: "Je vous ouvre la porte sur mon impact." },
      projets: { title: "Projets", message: "Je vous ouvre la porte sur mes initiatives." },
      contact: { title: "Contact", message: "Je vous ouvre la porte pour collaborer." }
    },
    // Results Section
    results: {
      title: "Résultats & Impact",
      subtitle: "Chiffres clés illustrant mon parcours et mon impact dans le domaine de la santé mentale."
    },
    // Avatar chat
    avatar: {
      goingToOpen: "Je vais ouvrir",
      openingDoor: "🚪 J'ouvre la porte...",
      welcome: "✨ Bienvenue !"
    },
    // Chatbot
    chat: {
      title: "Discutez avec Abimael",
      placeholder: "Posez une question...",
      send: "Envoyer",
      greeting: "Bonjour ! Je suis l'assistant virtuel d'Abimael. Comment puis-je vous aider ? Vous pouvez me poser des questions sur son parcours, ses compétences ou sur la santé mentale.",
      close: "Fermer"
    }
  },
  en: {
    // Navigation
    nav: {
      about: "About",
      skills: "Skills",
      experience: "Experience",
      education: "Education",
      projects: "Projects",
      contact: "Contact"
    },
    // Header
    header: {
      title: "Mental Health Practitioner · Parenting Coach"
    },
    // About Section
    about: {
      title: "About",
      subtitle: "Mental health practitioner, parenting coach and professional committed to child protection, international cooperation and mental health innovation.",
      bio: "I support families, teams and organizations in stress management, mental health, parenting and leadership development. My experience spans humanitarian contexts, corporate environments, training and psychosocial support. My approach is clinical, educational and strategic, with particular attention to dignity, resilience and inclusion.",
      expertise: [
        "Mental health & psychosocial",
        "Child protection",
        "International cooperation",
        "Coaching & leadership",
        "Digital innovation in mental health"
      ]
    },
    // Skills Section
    skills: {
      title: "Skills",
      subtitle: "A foundation combining mental health, protection, project management, pedagogy and digital tools.",
      mentalHealth: "Mental health & psychosocial",
      protection: "Protection & humanitarian",
      leadership: "Leadership, coaching & operations",
      pedagogy: "Analysis, pedagogy & digital",
      tools: "Tools",
      languages: "Languages",
      mentalHealthSkills: [
        "Individual, family and group psychological and psychosocial care",
        "Mental health needs assessment and treatment plan development",
        "Psychological First Aid (PFA) and crisis support",
        "Supervision and support of field teams on psychosocial aspects"
      ],
      protectionSkills: [
        "Child protection, GBV, case management and referral systems",
        "Needs analysis of populations affected by shocks and conflicts",
        "Collaboration with NGOs, UN agencies and institutional actors"
      ],
      leadershipSkills: [
        "Parenting coaching, personal development and leadership",
        "Supporting executives and managers in decision-making",
        "Analysis and optimization of operational processes"
      ],
      pedagogySkills: [
        "Design and facilitation of training (in-person and online)",
        "Experience in AI annotation and digital mental health tools"
      ]
    },
    // Experience Section
    experience: {
      title: "Professional Experience",
      subtitle: "A career at the intersection of mental health, protection, humanitarian work and corporate environments."
    },
    // Education Section
    education: {
      title: "Education & Degrees",
      subtitle: "An academic background rooted in psychology, education sciences, mental health and international cooperation.",
      degrees: "Main Degrees",
      certifications: "Selected Certifications"
    },
    // Projects Section
    projects: {
      title: "Projects & Commitments",
      subtitle: "Initiatives at the intersection of mental health, digital technology and training.",
      engagements: "Professional Engagements"
    },
    // Contact Section
    contact: {
      title: "Contact",
      subtitle: "For any collaboration, mission, coaching or project in mental health, protection or training.",
      email: "Email",
      languages: "Languages",
      location: "Current Location",
      sendMessage: "Send me a message",
      fullName: "Full Name",
      yourName: "Your name",
      subject: "Subject",
      subjectPlaceholder: "Subject of your message",
      message: "Message",
      messagePlaceholder: "Write your message here...",
      send: "Send message"
    },
    // Door messages
    door: {
      apropos: { title: "Welcome", message: "I'm opening the door to my journey." },
      competences: { title: "Key Skills", message: "I'm opening the door to my expertise." },
      experiences: { title: "Experience", message: "I'm opening the door to my field of action." },
      formations: { title: "Education", message: "I'm opening the door to my academic path." },
      resultats: { title: "Results", message: "I'm opening the door to my impact." },
      projets: { title: "Projects", message: "I'm opening the door to my initiatives." },
      contact: { title: "Contact", message: "I'm opening the door to collaboration." }
    },
    // Results Section
    results: {
      title: "Results & Impact",
      subtitle: "Key figures illustrating my journey and impact in the mental health field."
    },
    // Avatar chat
    avatar: {
      goingToOpen: "I'm going to open",
      openingDoor: "🚪 Opening the door...",
      welcome: "✨ Welcome!"
    },
    // Chatbot
    chat: {
      title: "Chat with Abimael",
      placeholder: "Ask a question...",
      send: "Send",
      greeting: "Hello! I'm Abimael's virtual assistant. How can I help you? You can ask me about his background, skills, or mental health topics.",
      close: "Close"
    }
  }
};

// Language labels for experiences (to translate job titles/companies)
export const experienceTranslations = {
  fr: {
    since: "Depuis",
    current: "En cours"
  },
  en: {
    since: "Since",
    current: "In progress"
  }
};
